/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ServiceProviders { 
    id?: string;
    serviceProviderName?: string;
    serviceProviderId?: string;
    accountEmail?: string;
    authenticationId?: string;
    contactPersonFirstName?: string;
    contactPersonLastName?: string;
    contactPersonEmail?: string;
    contactPersonPhoneNumber?: string;
    billingAddress?: string;
    status: number;
    applicationId?: string;
    vasLicenseId?: string;
    vasLicenseActiveDate?: Date;
    vasLicenseExpiryDate?: Date;
    approved?: string;
    tenantId?: string;
    onboardingStatus?: string;
    aggregatorIds?: Array<string>;
}
